import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state : {

    products: [],

    filters: [
      {slug: 'category', name: 'Research Area', filters: [], wp_name: 'product_cat'},
      {slug: 'type', name: 'Product Type', filters: [], wp_name: 'product_tag'},
      {slug: 'reactivity', name: 'Reactivity', filters: [], wp_name: 'reactivity'}
    ],

    orderby: [
      {title: 'Catalog No', value: 'catalog_no', select: true},
      {title: 'Name', value: 'name', select: false},
      {title: 'Price', value: 'price', select: false}
    ],

    search_value: '',

    currentPage : 1,

    currentOrderby : 'catalog_no',

    order: 'ASC',

    loader: true,

    addToCart: {
      show: false,
      name: '',
    },
  },

  actions: {
    getProducts ({ commit, state, getters }) {
      var category = [], tags = [], reactivity = [];

      if(getters.get_filters('category').length !== 0)
        category = getters.get_filters('category');

      if(getters.get_filters('type').length !== 0)
        tags = getters.get_filters('type');

      if(getters.get_filters('reactivity').length !== 0)
        reactivity = getters.get_filters('reactivity');

      axios
        .get('/wp-json/wp/v2/products/', {
          params: {
            filter_cat: category,
            filter_tag: tags,
            filter_react: reactivity,
            promo: state.promo,
            // count : 2,
            s: state.search_value,
            page: state.currentPage,
            orderby: state.currentOrderby,
            order: state.order,

          }
        })
        .then(response => { return response.data; })
        .then ( products => {

          commit('SET_PRODUCTS', products);
          commit('SET_LOADER', false);

        })
    },
  },

  getters: {
    get_filters: state => slug => {
      var el = state.filters
        .find(
          filters => filters.slug === slug
        ).filters
        .map(
          function(value) {
            return value.slug;
          });

      return el;
    },

    // get_orderby: state => {
    //   return state.orderby[1].value;
    // },

    get_selected_filters: state => {
      var val = state.filters.reduce(
        function(result, current) {
          return result.concat(current.filters);
        }, []);
      return val;
    },
  },

  mutations: {
    SET_PRODUCTS (state, products) {
      state.products = products;
    },

    SET_CURR_PAGE (state, currentPage) {
      state.currentPage = currentPage;
    },

    SET_SORT (state, orderbyValue) {
      if(state.currentOrderby == orderbyValue.value) {
        state.order = (orderbyValue.order ? (state.order == 'DESC') ? 'ASC' : 'DESC' : state.order);
      } else {
        state.order = 'ASC';
      }
      state.currentOrderby = orderbyValue.value;
    },

    UNSET_FILTERS(state, filterValue) {
      if(filterValue === true) {
        state.filters.map(
          function(element) {
            if(element.filters.length > 0) {
              element.filters = null;
              element.filters = [];
            }
            return element;
          });

      }
      else {
        var valIndex = state.filters[filterValue.fIndex].filters.findIndex(x => x.slug === filterValue.slug);
        state.filters[filterValue.fIndex].filters.splice(valIndex, 1);
      }
    },

    SET_FILTER(state, value) {
      console.log(value);
      console.log(state.filters);
    },

    SET_SEARCH(state, value) {
      var elements = document.getElementsByName('s');

      for (var i = 0; i < elements.length; i++) {
        elements[i].value = value;
      }

      state.search_value = value;
    },

    SET_LOADER(state, value) {
      state.loader = value;
    },

    SET_PROMO(state, value) {
      state.promo = value;
    },

    SET_ADD_CART(state, value) {
      state.addToCart = value;
    },

  }
});



// WEBPACK FOOTER //
// ./src/store/store.js